import { useTranslation } from 'react-i18next';
import { SelectOption } from '@anytag/shared-types';
import { QuerySocialAccountType } from '@anytag/graphql';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const SocialMediasField = (
  props: Omit<MultipleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const socialMediaOptions: SelectOption<QuerySocialAccountType>[] = [
    { label: t<string>('Facebook'), value: QuerySocialAccountType.FACEBOOK },
    { label: t<string>('Instagram'), value: QuerySocialAccountType.INSTAGRAM },
    { label: t<string>('Instagram Story'), value: QuerySocialAccountType.INSTAGRAM_BUSINESS },
    { label: t<string>('X(Twitter)'), value: QuerySocialAccountType.TWITTER },
    { label: t<string>('YouTube'), value: QuerySocialAccountType.YOUTUBE },
    { label: t<string>('TikTok'), value: QuerySocialAccountType.TIKTOK },
    { label: t<string>('Douyin'), value: QuerySocialAccountType.DOUYIN },
    { label: t<string>('Threads'), value: QuerySocialAccountType.THREADS },
    { label: t<string>('Xiaohongshu'), value: QuerySocialAccountType.XHS }
  ];

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="socialMedias"
      clearable={false}
      options={socialMediaOptions}
      title={t('Selector.Social Medias')}
      multiple
      {...props}
    />
  );
};
